module.exports = __webpack_public_path__ + "img/icon-navigation-add-cropped-light.de93a096.svg";